
<div class="step-indicators">
  <div *ngFor="let step of [1,2,3,4]" class="indicator" [class.active]="step <= currentStep">
    <span>{{ step }}</span>
  </div>
</div>

<form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

  <!-- Step 1 -->
  <div *ngIf="currentStep === 1">
    <div class="form-group custom-checkbox-group">
      <div *ngFor="let option of typeOptions" class="custom-checkbox">
        <input
          class="form-check-input"
          type="radio"
          [value]="option"
          formControlName="type"
          [id]="'type-' + option"
        />
        <label class="form-check-label" [for]="'type-' + option">
          <span class="custom-radio-circle"></span>
          <span class="label-text">{{ option }}</span>
        </label>
      </div>

      <div *ngIf="registrationForm.get('type')?.touched && registrationForm.get('type')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="row henterpant-mode invitation-steps">
      <div class="col-wrap col-lg-6 col-12">
        <div class="step-wrap step-1">
          <div class="number"><span>01</span></div>
          <h3 class="sub-title" [innerHTML]="'TEAM_SIGN_UP.INVITATION_STEPS.STEP1_TITLE' | translate"></h3>
          <p class="benefit" [innerHTML]="'TEAM_SIGN_UP.INVITATION_STEPS.STEP1_BENEFIT' | translate"></p>
          <ul>
            <li [innerHTML]="'TEAM_SIGN_UP.INVITATION_STEPS.STEP1_BULLET1' | translate"></li>
            <li [innerHTML]="'TEAM_SIGN_UP.INVITATION_STEPS.STEP1_BULLET2' | translate"></li>
          </ul>
        </div>
      </div>
      <div class="col-wrap col-lg-6 col-12">
        <div class="step-wrap step-2">
          <div class="number"><span>02</span></div>
          <h3 class="sub-title">{{'TEAM_SIGN_UP.INVITATION_STEPS.STEP2_TITLE' | translate}}</h3>
          <p [innerHTML]="'TEAM_SIGN_UP.INVITATION_STEPS.STEP2_DESC' | translate"></p>
        </div>
      </div>
    </div>

    <p class="label-one">{{'TEAM_SIGN_UP.INVITATION_CODE_QUESTION' | translate}}</p>
    <p class="label-two">{{'TEAM_SIGN_UP.INVITATION_CODE_BENEFIT' | translate}}</p>
    <div class="form-group with-icon mt-3 invitation-code-wrap">
      <i class="icon custom-link"></i>
      <input id="code" type="text" formControlName="code" class="form-control" placeholder="{{'TEAM_SIGN_UP.ENTER_CODE_PLACEHOLDER' | translate}}"/>
      <label for="code">{{'TEAM_SIGN_UP.ENTER_CODE_LABEL' | translate}}</label>
    </div>
  </div>

  <!-- Step 2 -->
  <div *ngIf="currentStep === 2">

    <div class="form-group with-icon" *ngIf="!studentCouncil">
      <label for="sportType">{{'TEAM_SIGN_UP.SPORT_TYPE' | translate}} <span class="req">*</span></label>
      <i class="icon custom-ball-football"></i>
      <div class="custom-dropdown">
        <select id="sportType" class="form-control custom-select" formControlName="sportType">
          <option value="" disabled>{{'TEAM_SIGN_UP.SELECT_SPORT_TYPE' | translate}}</option>
          <option *ngFor="let type of sportTypes | sportType"
                  [value]="type.id">
            {{ type.labelKey | translate }}
          </option>
        </select>
      </div>

      <div *ngIf="registrationForm.get('sportType')?.touched && registrationForm.get('sportType')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>


    <div class="form-group with-icon with-loader mt-3">
      <label for="club">{{(studentCouncil ? 'TEAM_SIGN_UP.SCHOOL' : 'TEAM_SIGN_UP.CLUB') | translate}} <span class="req">*</span></label>
      <i class="icon custom-highlight"></i>
      <input id="club" type="text" formControlName="club"
             (input)="onClubSearch($event)" autocomplete="off"/>
      <span class="loader" *ngIf="loadingClubs"></span>
      <ul *ngIf="clubOptions && clubOptions.length" class="suggestions-list club">
        <li *ngFor="let option of clubOptions" (click)="selectClubOption(option); $event.stopPropagation()">
          <div class="team">
            <p class="name">{{ option.name }}</p>
          </div>
        </li>
      </ul>

      <div *ngIf="registrationForm.get('club')?.touched && registrationForm.get('club')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="name">{{(studentCouncil ? 'TEAM_SIGN_UP.CLASS' : 'TEAM_SIGN_UP.TEAM_NAME') | translate}} <span class="req">*</span></label>
      <i class="icon custom-highlight"></i>
      <input formControlName="name" id="name" class="form-control"/>
      <div *ngIf="registrationForm.get('name')?.touched && registrationForm.get('name')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="form-group with-icon with-loader mt-3">
      <label for="address">{{'TEAM_SIGN_UP.ADDRESS' | translate}} <span class="req">*</span></label>
      <i class="icon custom-map-pin"></i>
      <input id="address" type="text"
             formControlName="address" (input)="onAddressSearch($event)"/>
      <span class="loader" *ngIf="loadingAddress"></span>
      <ul *ngIf="addressSuggestions.length" class="suggestions-list">
        <li *ngFor="let suggestion of addressSuggestions"
            (click)="selectAddress(suggestion);">
          {{ suggestion.displayName }}
        </li>
      </ul>
      <div *ngIf="registrationForm.get('address')?.touched && registrationForm.get('address')?.value">
        <p class="text-danger"
           *ngIf="registrationForm.get('address')?.errors?.['countryNotSupported']">
          {{'TEAM_SIGN_UP.ERRORS.COUNTRY_NOT_SUPPORTED' | translate: { selectedCountry: unsupportedCountryName, supportedCountries: getAllowedCountriesDisplay() } }}
        </p>
        <p class="text-danger"
           *ngIf="!registrationForm.get('address')?.errors?.['countryNotSupported'] && !selectedAddress">
          {{'TEAM_SIGN_UP.ERRORS.ADDRESS' | translate}}
        </p>
      </div>
    </div>

    <div class="form-group with-icon mt-3" *ngIf="!studentCouncil">
      <label for="league">{{'TEAM_SIGN_UP.LEAGUE_DIVISION' | translate}} </label>
      <i class="icon custom-trophy"></i>
      <input id="league" formControlName="league" class="form-control"/>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="age-group">{{'TEAM_SIGN_UP.AGE_GROUP' | translate}} <span class="req">*</span></label>
      <i class="icon custom-shirt"></i>
      <input formControlName="ageGroup" id="age-group" name="age-group" class="form-control"
             [placeholder]="'TEAM_SIGN_UP.AGE_GROUP_PLACEHOLDER' | translate"
             type="text"/>
      <div *ngIf="registrationForm.get('ageGroup')?.touched && registrationForm.get('ageGroup')?.invalid || (formError && formError.includes('age_group'))">
        <small class="text-danger" *ngIf="registrationForm.get('ageGroup')?.errors?.['required']">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small class="text-danger" *ngIf="registrationForm.get('ageGroup')?.errors?.['invalidFormat']">
          {{'TEAM_SIGN_UP.ERRORS.INVALID_FORMAT' | translate}}
        </small>
        <small class="text-danger" *ngIf="registrationForm.get('ageGroup')?.errors?.['invalidRange']">
          {{'TEAM_SIGN_UP.ERRORS.INVALID_RANGE' | translate}}
        </small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="number-of-players">{{(studentCouncil ? 'TEAM_SIGN_UP.NUMBER_OF_STUDENTS' : 'TEAM_SIGN_UP.NUMBER_OF_PLAYERS') | translate}} <span class="req">*</span></label>
      <i class="icon custom-users-group"></i>
      <input formControlName="numberOfPlayers" id="number-of-players" type="number" class="form-control"/>

      <div *ngIf="registrationForm.get('numberOfPlayers')?.touched && registrationForm.get('numberOfPlayers')?.invalid">
        <small class="text-danger" *ngIf="registrationForm.get('numberOfPlayers')?.errors?.['required']">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small class="text-danger" *ngIf="registrationForm.get('numberOfPlayers')?.errors?.['min']">
          {{'TEAM_SIGN_UP.ERRORS.MIN_PLAYERS' | translate}}
        </small>
      </div>

    </div>

    <div class="form-group with-icon mt-3" *ngIf="!studentCouncil">
      <label for="gender">{{'TEAM_SIGN_UP.GENDER' | translate}} <span class="req">*</span></label>
      <i class="icon icon-gender"></i>
      <div class="custom-dropdown">
        <select formControlName="gender" id="gender" class="form-control">
          <option value="">{{'TEAM_SIGN_UP.SELECT' | translate}}</option>
          <option value="male">{{'TEAM_SIGN_UP.MALE' | translate}}</option>
          <option value="female">{{'TEAM_SIGN_UP.FEMALE' | translate}}</option>
        </select>
      </div>

      <div *ngIf="registrationForm.get('gender')?.touched && registrationForm.get('gender')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>
  </div>

  <!-- Step 3 -->
  <div *ngIf="currentStep === 3">
    <div class="form-group with-icon">
      <label for="manager-name">{{'TEAM_SIGN_UP.MANAGER_NAME' | translate}} <span class="req">*</span></label>
      <i class="icon custom-id-badge"></i>
      <input formControlName="managerName" id="manager-name" class="form-control"/>
      <div *ngIf="registrationForm.get('managerName')?.touched && registrationForm.get('managerName')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label>{{'TEAM_SIGN_UP.MANAGER_ADDRESS' | translate}} <span class="req">*</span></label>
      <i class="icon custom-map-pin"></i>
      <input formControlName="managerAddress" class="form-control"/>
      <div *ngIf="registrationForm.get('managerAddress')?.touched && registrationForm.get('managerAddress')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="manager-address">{{'TEAM_SIGN_UP.CONTACT_PERSON_NAME' | translate}} <span class="req">*</span></label>
      <i class="icon custom-user-circle"></i>
      <input formControlName="contactPersonName" id="manager-address" class="form-control"/>
      <div *ngIf="registrationForm.get('contactPersonName')?.touched && registrationForm.get('contactPersonName')?.invalid">
        <small class="text-danger">{{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}</small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="phone">{{'TEAM_SIGN_UP.PHONE' | translate}} <span class="req">*</span></label>
      <!-- <i class="icon custom-c-phone"></i> -->
      <ngx-intl-tel-input
        [cssClass]="'form-control phone-control'"
        [enableAutoCountrySelect]="false"
        [enablePlaceholder]="isBrowser"
        [searchCountryFlag]="true"
        [searchCountryField]="searchCountryFields"
        [selectFirstCountry]="false"
        [preferredCountries]="preferredCountries"
        [onlyCountries]="onlyCountries"
        [phoneValidation]="true"
        [separateDialCode]="true"
        [maxLength]="15"
        [selectedCountryISO]="selectedCountryISO"
        (countryChange)="onPhoneCountryChange($event)"
        inputId="phone"
        formControlName="phone">
      </ngx-intl-tel-input>
      <div *ngIf="registrationForm.get('phone')?.touched && registrationForm.get('phone')?.invalid || (formError && formError.profile)">
        <small *ngIf="registrationForm.get('phone')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small *ngIf="registrationForm.get('phone')?.errors?.['validatePhoneNumber']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.PHONE_INVALID' | translate}}
        </small>
        <small *ngIf="formError && formError.profile.phone_number" class="text-danger">
          {{formError.profile.phone_number[0]}} <!-- TODO -->
        </small>
      </div>
    </div>

    <div class="form-group with-icon mt-3">
      <label for="email">{{'TEAM_SIGN_UP.EMAIL' | translate}} <span class="req">*</span></label>
      <i class="icon custom-c-mail"></i>
      <input id="email" type="email" formControlName="email" class="form-control" />
      <div *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid || (formError && formError.email)">
        <small *ngIf="registrationForm.get('email')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small *ngIf="registrationForm.get('email')?.errors?.['email']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.EMAIL_INVALID' | translate}}
        </small>
        <small *ngIf="formError && formError.email" class="text-danger">
          {{formError.email}}
        </small>
      </div>
    </div>
  </div>

  <!-- Step 4 -->
  <div *ngIf="currentStep === 4">
    <!-- Password -->
    <div class="form-group mt-3">
      <label for="password">{{'TEAM_SIGN_UP.PASSWORD' | translate}} <span class="req">*</span></label>
      <input id="password" class="form-control"
             formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
         (click)="togglePasswordVisibility('password')"></i>
      <div *ngIf="registrationForm.get('password')?.touched && registrationForm.get('password')?.invalid">
        <small *ngIf="registrationForm.get('password')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small *ngIf="registrationForm.get('password')?.errors?.['minlength']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.PASSWORD_MIN' | translate}}
        </small>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="form-group mt-3">
      <label for="confirmPassword">{{'TEAM_SIGN_UP.CONFIRM_PASSWORD' | translate}} <span class="req">*</span></label>
      <input id="confirmPassword" class="form-control"
             [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showConfirmPassword, 'icon-eye-closed': !showConfirmPassword}"
         (click)="togglePasswordVisibility('confirmPassword')"></i>
      <div *ngIf="registrationForm.get('confirmPassword')?.touched && (registrationForm.get('confirmPassword')?.invalid || registrationForm.hasError('passwordsMismatch'))">
        <small *ngIf="registrationForm.get('confirmPassword')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.TYPE_REQ' | translate}}
        </small>
        <small *ngIf="registrationForm.get('confirmPassword')?.errors?.['minlength']" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.CONFIRM_PASSWORD_MIN' | translate}}
        </small>
        <small *ngIf="registrationForm.hasError('passwordsMismatch')" class="text-danger">
          {{'TEAM_SIGN_UP.ERRORS.PASSWORDS_MISMATCH' | translate}}
        </small>
      </div>
    </div>

    <div class="form-check mt-3">
      <input type="checkbox" formControlName="emailSubscription" />
      <label>
        {{'TEAM_SIGN_UP.EMAIL_SUBSCRIPTION' | translate}}
      </label>
    </div>

    <div class="form-check mt-3 mb-3">
      <input type="checkbox" formControlName="confirmTerms" />
      <label>
        {{'SUBSCRIPTION.ACCEPT_1' | translate}} <a (click)="goToTermsConditions()" target="_blank">{{'SUBSCRIPTION.T&C' | translate}}</a>
        {{'SUBSCRIPTION.ACCEPT_2' | translate}} <a (click)="goToPrivacyPolicy()">{{'SUBSCRIPTION.P&P' | translate}}</a>
        <span class="text-danger">*</span>
      </label>
    </div>

  </div>

  <small *ngIf="error" class="text-danger">
    {{errorMessage}}
  </small>

  <div *ngIf="currentStep === 4">
    <p *ngFor="let key of objectKeys(formError || {})" class="mt-2 align-items-center">
      <small class="text-danger">
        {{ formError[key] }}
      </small>
    </p>
  </div>

  <!-- Step Buttons -->
  <div class="step-buttons {{'step-' + currentStep}} mt-4">
    <button type="button" class="btn btn-secondary"
      (click)="goPreviousStep()" *ngIf="currentStep > 1">
      {{'TEAM_SIGN_UP.PREVIOUS_BUTTON' | translate}}
    </button>

    <button type="button" class="btn btn-primary-henterpant"
      (click)="goNextStep()" *ngIf="currentStep < 4"
      [disabled]="!isCurrentStepValid()">
      {{'TEAM_SIGN_UP.NEXT_BUTTON' | translate}}
    </button>

    <button type="submit" class="btn btn-primary-henterpant with-loader"
      *ngIf="currentStep === 4" [disabled]="!isCurrentStepValid() || loading">
      {{'TEAM_SIGN_UP.SIGN_UP_BUTTON' | translate}} <span class="loader" *ngIf="loading"></span>
    </button>
  </div>


</form>


